import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-8 form-container" }
const _hoisted_5 = {
  key: 0,
  class: "d-flex centered"
}
const _hoisted_6 = {
  key: 0,
  class: "d-flex centered"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "d-flex centered" }
const _hoisted_9 = { class: "d-flex" }
const _hoisted_10 = { class: "col-6 subject-spacing" }
const _hoisted_11 = { class: "col-6 email-spacing" }
const _hoisted_12 = { class: "col-lg-4 row" }
const _hoisted_13 = { class: "col-6 link-wrapper" }
const _hoisted_14 = { class: "col-6 link-wrapper" }
const _hoisted_15 = { class: "d-flex" }
const _hoisted_16 = { href: "mailto:mohammadrk804@gmail.com" }
const _hoisted_17 = {
  href: "https://www.linkedin.com/in/mohammad-karim-331559164",
  target: "_blank",
  rel: "noopener noreferrer",
  class: "icon--spacing"
}
const _hoisted_18 = { class: "text-center" }

import {ref, watch} from 'vue';
import store from '@/store';

import NavbarLink from './NavbarLink.vue';
import {contact} from '../service/contactService';
import {isValidEmail} from '../util/generalUtil';


export default /*@__PURE__*/_defineComponent({
  __name: 'AppFooter',
  setup(__props) {

const sent = ref(false);
const loading = ref(false);
const invalid = ref(false);

watch(
  () => store.state.emailSent,
  value => {
    if (value) {
      sent.value = store.state.emailSent;
    }
  },
);

const scrollToTop = () => {
  window.scrollTo(0, 0);
};

const formData = {
  subject: '',
  email: '',
  message: '',
};

const submit = async () => {
  try {
    if (
      !isValidEmail(formData.email) ||
      formData.subject.trim() === '' ||
      formData.message.trim() === ''
    ) {
      invalid.value = true;
      return;
    }
    loading.value = true;
    setTimeout(() => {
      loading.value = false;
      sent.value = true;
      store.dispatch('setEmailSent', true);
    }, 2000);
    await contact({
      subject: formData.subject,
      email: formData.email,
      message: formData.message,
    });
  } catch (error) {
    loading.value = false;
    sent.value = true;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[9] || (_cache[9] = _createElementVNode("p", { class: "header text-center" }, "Get in touch", -1)),
          (sent.value || loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (loading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[5] || (_cache[5] = [
                      _createElementVNode("div", {
                        class: "spinner-border text-success",
                        role: "status"
                      }, [
                        _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                      ], -1)
                    ]))]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: ['fas', 'thumbs-up'],
                          size: "2xl",
                          class: "text--green"
                        })
                      ]),
                      _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text--green text-center mt-3" }, [
                        _createTextVNode(" Thank You! "),
                        _createElementVNode("br"),
                        _createTextVNode(" Your message has been sent successfully "),
                        _createElementVNode("br"),
                        _createTextVNode("I will get back to you as soon as possible ")
                      ], -1))
                    ]))
              ]))
            : (_openBlock(), _createElementBlock("form", {
                key: 1,
                class: _normalizeClass(["needs-validation", {'was-validated': invalid.value}]),
                novalidate: "",
                onSubmit: _withModifiers(submit, ["prevent"])
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      placeholder: "Subject",
                      class: "form-control",
                      id: "FormControlSubject",
                      required: "",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.subject) = $event)),
                      onInput: _cache[1] || (_cache[1] = ($event: any) => (sent.value = false))
                    }, null, 544), [
                      [_vModelText, formData.subject]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _withDirectives(_createElementVNode("input", {
                      type: "email",
                      placeholder: "Email",
                      class: "form-control",
                      id: "FormControlEmail",
                      required: "",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.email) = $event)),
                      onInput: _cache[3] || (_cache[3] = ($event: any) => (sent.value = false))
                    }, null, 544), [
                      [_vModelText, formData.email]
                    ]),
                    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "invalid-feedback" }, " Please enter a valid email address ", -1))
                  ])
                ]),
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("textarea", {
                    id: "FormControlMessage",
                    class: "form-control mt-3",
                    placeholder: "Message",
                    "aria-label": "With textarea",
                    rows: "5",
                    required: "",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.message) = $event))
                  }, "              ", 512), [
                    [_vModelText, formData.message]
                  ])
                ]),
                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "d-flex send-button mt-3" }, [
                  _createElementVNode("button", {
                    class: "btn button col-12",
                    type: "submit"
                  }, "SEND")
                ], -1))
              ], 34))
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", null, [
              _cache[10] || (_cache[10] = _createElementVNode("p", { class: "header text-align-start" }, "Important Links", -1)),
              _createElementVNode("div", null, [
                _createVNode(NavbarLink, {
                  class: "link",
                  name: "About Me",
                  to: "",
                  onClick: scrollToTop
                }),
                _createVNode(NavbarLink, {
                  class: "link",
                  name: "Projects",
                  onClick: scrollToTop
                }),
                _createVNode(NavbarLink, {
                  class: "link",
                  name: "Contact",
                  onClick: scrollToTop
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", null, [
              _cache[11] || (_cache[11] = _createElementVNode("p", null, "Feel free to reach out! I'm open to new connections.", -1)),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("a", _hoisted_16, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: ['fas', 'envelope'],
                    size: "2xl",
                    class: "text--green"
                  })
                ]),
                _createElementVNode("a", _hoisted_17, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: ['fab', 'linkedin'],
                    size: "2xl",
                    class: "text--green"
                  })
                ])
              ])
            ])
          ])
        ])
      ]),
      _cache[12] || (_cache[12] = _createElementVNode("hr", { class: "mt-5" }, null, -1)),
      _createElementVNode("p", _hoisted_18, " © " + _toDisplayString(new Date().getFullYear()) + " Mohammad Karim. All rights reserved. ", 1)
    ])
  ]))
}
}

})